function getVideos(state) {
  return { videos: state.step2Module1.multimedias.videos.filter(videos => !videos.delete) };
}

function getVideos360(state) {
  return { tour360: state.step2Module1.multimedias.tour360.filter(video => !video.delete) };
}

function getPictures(state) {
  const imagesToShow = state.step2Module1.multimedias.pictures.filter(picture => !picture.delete);
  return { images: imagesToShow };
}

function getPlans(state) {
  const plans = state.step2Module1.multimedias.plan.filter(picture => !picture.delete);
  return { plans };
}

function processingMultimedias(state) {
  return Object.values(state.step2Module1.processing).some(v => v === true);
}

function getMultimediaState(state) {
  return {
    videos: getVideos(state),
    tour360: getVideos360(state),
    images: getPictures(state),
    plans: getPlans(state),
    processing: processingMultimedias(state)
  };
}

function validate(state) {
  return {
    pictures: state.step2Module1.multimedias.pictures
      ? state.step2Module1.multimedias.pictures.filter(picture => !picture.delete && !picture.error)
      : null,
    videos: state.step2Module1.multimedias.videos
      ? state.step2Module1.multimedias.videos.filter(video => !video.delete)
      : null,
    tour360: state.step2Module1.multimedias.tour360
      ? state.step2Module1.multimedias.tour360.filter(tour360 => !tour360.delete)
      : null,
    plans: state.step2Module1.multimedias.plans
      ? state.step2Module1.multimedias.plans.filter(plan => !plan.delete && !plan.error)
      : null
  };
}

function onlyChanged(arr = []) {
  return arr.filter(p => (!p.id_multimedia || p.updated || p.delete) && !p.error);
}

function stepData(state) {
  return {
    pictures: [
      ...onlyChanged(state.step2Module1.multimedias.pictures),
      ...onlyChanged(state.step2Module1.multimedias.plan)
    ],
    videos: [
      ...onlyChanged(state.step2Module1.multimedias.videos),
      ...onlyChanged(state.step2Module1.multimedias.tour360)
    ]
  };
}

function getSavedMedia(state) {
  return { originalMultimedia: state.step2Module1.originalMultimedia };
}

export { getPictures, validate, stepData, getVideos, getPlans, getVideos360, getSavedMedia, getMultimediaState };
